import styled from 'styled-components';
import JobActions from './JobActions';
import { colorSchema } from 'utils/style';

export default styled(JobActions)`
  .job-actions {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 100%;
    padding: 1.6rem 0;
    position: relative;
    border-bottom: 1px solid ${colorSchema('grey200')};
    padding-top: 1.6rem;

    &__options {
      display: flex;
      flex-flow: column;
      width: 100%;
    }

    &__loading {
      display: flex;
      margin: 2rem 0;
      justify-content: center;
      width: 100%;
    }

    &__dropdown {
      padding: 1rem;
    }

    &__dropdown-list {
      list-style: none;
      margin: 0.8rem 0;
      padding: 0;
    }

    &__dropdown-item {
      border-bottom: 1px solid ${colorSchema('grey300')};
      cursor: pointer;
      display: flex;
      margin-bottom: 0.8rem;
      padding-bottom: 0.8rem;

      &:last-of-type {
        border: 0;
        margin-bottom: 0;
        padding-bottom: 0;
      }

      &:hover {
        background-color: ${colorSchema('grey100')};
      }
    }

    &__dropdown-item-icon {
      display: flex;
      padding-right: 2rem;

      svg {
        fill: ${colorSchema('grey300')};
      }
    }

    &__dropdown-item-text {
      display: flex;
      flex-direction: column;
    }

    &__dropdown-item-plate {
      color: ${colorSchema('grey900')};
      font-size: 1.8rem;
      font-weight: bold;
    }

    &__dropdown-item-type {
      color: ${colorSchema('grey700')};
      font-size: 1.8rem;
    }

    &__dropdown-button {
      margin-bottom: 2.4rem;
    }

    &__dropdown-title {
      color: ${colorSchema('grey700')};
      font-size: 1.4rem;
      font-weight: 500;
      margin-bottom: 1.6rem;
      text-transform: uppercase;
    }
  }
`;
